import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name}`);
        // clean hash then go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-xs font-mono uppercase tracking-widest text-[var(--text-secondary)]" data-testid="auth-callback-status">
        Signing you in&hellip;
      </div>
    </div>
  );
}
